import { Box, FloraButton, Flex, Image, styled } from '@grupoboticario/flora-react';

import { Skeleton } from 'components';

export const styles = {
  CarouselWrapper: styled(Box, {
    '.slick-track': {
      display: 'flex',
      gap: '$4',
    },
  }),

  WithoutCarouselWrapper: styled(Flex, {
    gap: '$4',
    padding: '$0 $12',

    '@tablet': {
      padding: '$0 $12',
    },
  }),

  Image: styled(Image, {
    borderRadius: '$small',
    overflow: 'hidden',
    cursor: 'pointer',
    '&[data-isolated]': {
      '@desktop': {
        maxWidth: 'calc(100% / 4 - $4)',
      },
    },
  }),

  SkeletonCarouselWrapper: styled(Flex, {
    alignItems: 'center',
    gap: '$4',
    marginTop: '$6',
    padding: '$0',
  }),

  SkeletonImage: styled(Skeleton, {
    height: '40vh',
    width: '100%',

    '@desktop': {
      width: 'calc(100% / 4)',
      height: '270px',
    },
  }),

  TitleWrapper: styled(Flex, {
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    gap: '$6',

    '@tablet': {
      justifyContent: 'flex-start',
    },
  }),

  LastItemImage: styled(Image, {
    objectFit: 'contain',
    objectPosition: 'center',
    opacity: '0.2',
    position: 'relative',
    zIndex: '-1',
  }),

  LastItemButton: styled(FloraButton, {
    position: 'absolute',
  }),
};

export default styles;
